import React, { Component } from "react";
import { Spin } from "antd";
// 接口以及调用接口方法
import { faultReportCityTrend, faultTrend } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// 组件
import NoData from "@/components/common/no_data";
// icon
import Echarts from "echarts";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class ExceptionPieChart extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.chartId = this.props.chartId ? this.props.chartId : ""; // 设置告警饼图 id
    this.state = {
      showSping: true, // loading加载是否显示：true，显示，false，不显示
      param: {
        cityIds: this.props.param.cityIds,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        isMonth: this.props.param.isMonth,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      pieData: [],
      noData: false,
    };
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds &&
      nextProps.param.cityIds === this.state.param.cityIds &&
      nextProps.param.isMonth === this.state.param.isMonth &&
      nextProps.param.operationProperty === this.state.param.operationProperty &&
      nextProps.param.operationMode === this.state.param.operationMode &&
      nextProps.param.date === this.state.param.date
    ) {
      // console.log("饼图数据一样");
    } else {
      this.setState(
        {
          showSping: true, // loading加载是否显示：true，显示，false，不显示
          param: {
            isMonth:nextProps.param.isMonth,
            cityIds: nextProps.param.cityIds,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          this.getPieDate();
        },
      );
    }
  }

  // 获取数据
  getPieDate() {
    const func = this.props.pieType === "1" ? faultTrend : faultReportCityTrend;
    // 获取成功率趋势数据
    fetchHandler(func, {
      isHourDetail:1,
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
      isMonth: this.state.param.isMonth,
    }).then((res) => {
      this.setState({
        showSping: false, // loading加载是否显示：true，显示，false，不显示
      });
      if (res.data) {
        this.setState(
          {
            pieData: [...res.data],
            noData: !res.data.length > 0,
          },
          () => {
            this.renderChart();
          },
        );
      } else {
        this.setState({
          noData: true,
        });
      }
    });
  }

  componentDidMount() {
    this.getPieDate();
  }

  //  故障等级排布饼图
  renderChart() {
    if (document.getElementById(`pie${this.chartId}`) && document.getElementById(`pie${this.chartId}`) != null)
    {
    this.titleLeft = document.getElementById(`pie${this.chartId}`).clientWidth * 0.3 - 28;
    }
    window.removeEventListener("resize", () => {});
    const { pieData } = this.state;
    // 数据设置
    let data = [];
    let dataLen = [];
    let colors = [];

    if (pieData.length === 0) {
      data = [{ name: "暂无数据", value: 0 }];
      dataLen = [];
      colors = ["#d8d8d8"];
    } else {
      // 数据
      pieData.map((item) => {
        if (this.props.pieType === "1") {
          // 故障等级分布
          data.push({
            name: item.levenName,
            value: item.proportion,
          });
          dataLen.push({
            name: item.levenName,
            icon: "circle",
          });
          colors.push(item.color);
          return true;
        } else {
          //  故障城市分布
          data.push({
            name: item.cityName,
            value: item.cityProportion ? item.cityProportion : 0,
          });
          dataLen.push({
            name: item.cityName,
            icon: "circle",
          });
          // colors.push(item.color);
          return true;
        }
      });
    }

    const myChart = Echarts.init(document.getElementById(`pie${this.chartId}`));
    const option = {
      title: {
        show: true,
        text: this.props.pieType === "1" ? "故障等级占比情况" : "TOP5 故障产生地区占比情况",
        bottom: 10,
        left: dataLen.length > 0 ? this.titleLeft : "center",
        textStyle: {
          fontSize: 14,
        },
      },
      tooltip: {
        show: dataLen.length > 0,
        backgroundColor: "rgba(0,0,0,.5)",
        formatter: (params) => {
          const str = `<div style="padding:10px 24px 10px 10px;">${params.data.name}:${params.data.value}%</div>`;
          return str;
        },
      },
      color: this.props.pieType === "1" ? colors : ["#CF1322", "#FA541C", "#FA8C16", "#40A9FF", "#cccccc"],
      legend: {
        textStyle: {
          padding: [10, 0],
        },
        data: dataLen,
        formatter: (name) => {
          let value = "";
          data.map((item) => {
            if (item.name === name) {
              value = `${item.value}%`;
            }
            return true;
          });

          return `${name}   ${value}`;
        },
        right: 12,
        top: "middle",
        orient: "vertical",
      },
      series: {
        type: "pie",
        name: this.props.pieType === "1" ? "等级" : "城市",
        radius: ["30%", "50%"],
        hoverAnimation: dataLen.length > 0,
        silent: !dataLen.length > 0,
        center: dataLen.length > 0 ? ["30%", "50%"] : ["50%", "50%"],
        labelLine: {
          show: false,
        },
        label: {
          show: !dataLen.length > 0,
          position: "center",
          color: "#333",
        },
        data: data,
      },
    };
    myChart.clear();
    myChart.setOption(option);
    window.addEventListener("resize", () => {
      if (this.props.panelsInfo.activeKey === "0001") {
        if (document.getElementById(`pie${this.chartId}`) && document.getElementById(`pie${this.chartId}`) != null)
    {
        this.titleLeft = document.getElementById(`pie${this.chartId}`).clientWidth * 0.3 - 28;
        }
        myChart.resize();
      }
    });
  }

  render() {
    const content = (
      <div className="exception-pie-chart">
        <Spin spinning={this.state.showSping}>
          <div className="pie" id={`pie${this.chartId}`}></div>
          {this.state.noData ? (
            <div className="no_data_com no_data_line no_border">
              <NoData />
            </div>
          ) : null}
        </Spin>
      </div>
    );

    return content;
  }
}

export default injectIntl(ExceptionPieChart);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/exceptionPieChart.js